<template>
	<div class="page-detail">
		<div class="d-inline-block">
			<div v-for="(arr, idx) of desc" :key="idx" class="sec">
				<template v-if="arr.type == 'image'">
					<a :href="arr.src" v-if="arr.src" target="_blank">
						<img :src="arr.url" class="obj w-100" @load="refresh++" />
					</a>
					<img :src="arr.url" class="obj w-100" @load="refresh++" v-else />
				</template>
				<template v-if="arr.type == 'video'">
					<video :src="arr.url" class="w-100" controls autoplay muted loop></video>
				</template>

				<template v-if="arr.type == 'slider'">
					<div class="slider" :class="title" :style="[arr.background ? { 'background-image': 'url(' + arr.background + ')' } : '']">
						<carousel :settings="settings" :key="refresh">
							<slide v-for="src in arr.url" :key="src">
								<img :src="src" class="obj w-100" />
							</slide>
							<template #addons>
								<Navigation />
							</template>
						</carousel>
					</div>
				</template>
			</div>
			
		</div>
	</div>
			
	<div id="page-navi" class="page-navi">
		<router-link tag="div" :to="'/portfolio/project/' + prev.path" class="bt-prev">
			<span>Prev</span>
			<div class="title">
				{{ prev.title }}
			</div>
		</router-link>
		<router-link tag="div" :to="'/portfolio/project/' + next.path" class="bt-next">
			<span>Next</span>
			<div class="title">
				{{ next.title }}
			</div>
		</router-link>
	</div>
</template>

<script>
import { Carousel, Slide, Navigation } from 'vue3-carousel'

export default {
	name: 'Page.Project.Detail',
	components: {
		Carousel,
		Slide,
		Navigation,
	},
	data() {
		return {
			refresh		: 0,
			works 		: [],
			desc		: [],
			title		: '',
			next 		: {
				title	: '',
				path	: '',
			},
			prev 		: {
				title	: '',
				path	: '',
			},
			settings: {
				itemsToShow	: 2.5,
				snapAlign	: 'center',
			},
		}
	},
	mounted() {
		this.getData()

		document.addEventListener('scroll',this.setScroll)
	},
	unmounted() {
		document.removeEventListener('scroll', this.setScroll)
		
	},
	methods: {
		getData() {
			this.works = this.$root.works
			this.desc = []

			for(var i=0; i<this.works.length; i++) {
				if(this.$route.params.title == this.works[i].title.toLowerCase().replace(/\s/g,'-')) {
					this.desc = this.works[i].description
					this.$root.theme = this.works[i].theme
					this.title = this.works[i].title
					if(this.title == 'Bidsqare') {
						this.settings = {
							itemsToShow	: 1,
							wrapAround 	: true,
						}
					}else{
						this.settings = {
							itemsToShow	: 2.2,
							snapAlign	: 'center',
						}
					}

					var startNum = 0
					var endNum = 0

					
					if (i > 0) {
						startNum = i - 1
					}else{
						startNum = this.works.length - 1
					}
					this.prev = {
						title	: this.works[startNum].title,
						path 	: this.works[startNum].title.toLowerCase().replace(/\s/g,'-')
					}

					if(i == this.works.length - 1) {
						endNum = 0
					}else{
						endNum = i + 1
					}

					this.next = {
						title 	: this.works[endNum].title,
						path	: this.works[endNum].title.toLowerCase().replace(/\s/g,'-')
					}
				}
			}

			setTimeout(() => {
				const fElem = document.querySelector('.sec:first-child')
				const pageNavi = document.getElementById('page-navi')

				if(fElem) fElem.classList.add('on')
				if(pageNavi) pageNavi.classList.add('on')

			}, 500)

			setTimeout(() => {
				this.setScroll()
			}, 1000)
		},
		setScroll() {
			const scrTop = document.documentElement.scrollTop
			const secAll = document.querySelectorAll('.sec')
			const scrHeight = screen.height

			for(const sec of secAll) {
				if(scrTop > sec.offsetTop - (scrHeight-200)) {
					sec.classList.add('on')
				}
			}
		},
		removeStyle() {
			const secAll = document.querySelectorAll('.sec')
			const pageNavi = document.getElementById('page-navi')

			for(const sec of secAll) {
				sec.classList.remove('on')
			}

			pageNavi.classList.remove('on')
		},
	},
	watch: {
		$route() {
			this.desc = []
			this.removeStyle()
			setTimeout(() => {
				this.getData()
			}, 500)
		},
	}
}
</script>

<style scoped lang="scss">
    @import '@/assets/scss/project.detail.scss';
</style>